import React, { useState } from 'react'

import { F0Box, F0Checkbox, F0Icon, F0Text } from '@factorialco/f0-react'
import { ChevronDown, ChevronUp } from '@factorialco/f0-react/icons/app'

type FilterOption = {
  value: string
  label: string
}

type FilterAccordionProps = {
  id: string
  label: string
  options: FilterOption[]
  selectedValues: string[]
  onChange: (values: string[]) => void
  defaultExpanded?: boolean
}

export const FilterAccordion: React.FC<FilterAccordionProps> = ({
  id,
  label,
  options,
  selectedValues,
  onChange,
  defaultExpanded = false,
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded)

  const handleToggle = (value: string, checked: boolean) => {
    if (checked) {
      onChange([...selectedValues, value])
    } else {
      onChange(selectedValues.filter((v) => v !== value))
    }
  }

  return (
    <F0Box display="flex" flexDirection="column">
      <div
        role="button"
        tabIndex={0}
        className="flex justify-between items-center py-2.5 px-3 cursor-pointer rounded-sm transition-colors hover:bg-f1-background-secondary"
        onClick={() => setExpanded(!expanded)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') setExpanded(!expanded)
        }}
      >
        <F0Text variant="description" content={label} />
        <div className="opacity-50 shrink-0">
          <F0Icon icon={expanded ? ChevronUp : ChevronDown} size="sm" />
        </div>
      </div>

      {expanded && (
        <F0Box display="flex" flexDirection="column" gap="md" padding="sm">
          {options.map((option) => (
            <F0Checkbox
              key={`${id}-${option.value}`}
              title={option.label}
              checked={selectedValues.includes(option.value)}
              onCheckedChange={(checked) => handleToggle(option.value, !!checked)}
            />
          ))}
        </F0Box>
      )}
    </F0Box>
  )
}
